<template>
	<div style="user-select: none">
		<sf-data-table :columns="columns" :rows="rows" index />
	</div>
</template>
<script>
import client from '@/api/client';
import moment from 'moment';
import { emitSyncDate } from '@common/WidgetComponent/common';
import { BASE_URL } from '@/constants';

const api = {
	selectNotifications: () => client.get(`${BASE_URL}/notification/v1/select?useYn=Y&pageUnit=20&currentPage=1`).then(res => res.data)
};
export default {
	async created() {
		this.refresh();
	},
	methods: {
		refresh() {
			return api.selectNotifications().then(res => {
				this.rows = res.body.result.map(r => ({ ...r, regDt: moment(r.regDt).format('YYYY-MM-DD') }));
				emitSyncDate(this);
				return this.rows;
			});
		}
	},
	data() {
		return {
			syncDate: null,
			columns: [
				{ label: '제목', prop: 'notiTitle', minWidth: 200, className: 'notification___nowrap' },
				{ label: '등록일', prop: 'regDt', width: 120 },
				{ label: '등록자', prop: 'regId', width: 130 }
			],
			rows: [{ title: '공지1', regDt: '2021-05-27', regId: 'SJD' }]
		};
	}
};
</script>

<style></style>
